export default __webpack_public_path__ + "static/generative-stative-compound-intransitive-a041de7f1d29f69c56d796390314837a.svg";